import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/home/index.vue";
import TnC from "../views/tncs/index.vue";

const routes = [
    {
        path: "/content/:pid?/:aid?", // or "/content/:pid" depending on your needs
        name: "home",
        component: Home,
    },
    {
        path: "/content/tnc",
        name: "tnc",
        component: TnC,
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "active",
});

export default router;
